<ng-container *transloco="let t;">

  <h2>{{ t('common.labels.documents') }}</h2>
  <p *ngIf="needsJobDescription">
    <strong [ngClass]="{error: hasJobError}">{{ t('orderform.please_upload_jobdescription') }}</strong><br>
  </p>

  <p-fileUpload
    name="myfile[]"
    multiple="multiple"
    accept=".jpg,.png,.gif,.pdf,.doc,.docx,.ppt,.pptx"
    maxFileSize="10000000"
    customUpload="true"
    [chooseLabel]="t('common.labels.add')"
    [chooseStyleClass]="'p-button-secondary p-button-outlined'"
    [showUploadButton]="false"
    [showCancelButton]="false"
    (onSelect)="setFiles($event)"
    (onClear)="clearFiles($event)"
    [invalidFileSizeMessageSummary]="t('common.messages.invalidFileSizeMessageSummary')"
    [invalidFileSizeMessageDetail]="t('common.messages.invalidFileSizeMessageDetail')"
    [invalidFileTypeMessageSummary]="t('common.messages.invalidFileTypeMessageSummary')"
    [invalidFileTypeMessageDetail]="t('common.messages.invalidFileTypeMessageDetail')"
    [invalidFileLimitMessageDetail]="t('common.messages.invalidFileLimitMessageDetail')"
    [invalidFileLimitMessageSummary]="t('common.messages.invalidFileLimitMessageSummary')"
    >
    <ng-template pTemplate="content" let-files>
      <div *ngIf="files.length === 0" style="text-align: center;">{{ t('common.labels.choose_files') }}</div>
    </ng-template>

    <ng-template let-file pTemplate="file">
      <div class="p-grid p-fluid p-ai-center" *ngIf="settings[file.name]">
        <div class="p-col-3">
          <p>{{ settings[file.name].name }}</p>
        </div>
        <div class="p-col-3">
          <p>{{ settings[file.name].size }}</p>
        </div>
        <div class="p-col-3">
          <app-form-control *ngIf="settings[file.name].control" [cid]="file.name" [control]="settings[file.name].control" [type]="'select'" [options]="optionsDocumenttypes" [showLabel]="false"></app-form-control>
        </div>
        <div class="p-col-3 p-text-right">
          <button pButton (click)="removeFile(file)" type="button" icon="pi pi-trash" class="p-button-outlined danger-button"></button>
        </div>
      </div>
    </ng-template>

  </p-fileUpload>

</ng-container>
